'use es6';

import { TABLE_HEADER_BACKGROUND_COLOR } from 'HubStyleTokens/theme';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import styled, { css } from 'styled-components';
import UIExpandableText, { EXPANDABLE_TEXT_HEIGHT_OFFSET } from 'UIComponents/text/UIExpandableText';
import Oas from '../../../lib/api-explorer/models/Oas';
import capitalizeFirstLetter from '../../../lib/utils/capitalizeFirstLetter';
import { flatten, flattenResponseSchema, getOneOfTypes } from '../utils/flatten';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Code from 'UIComponents/elements/Code';
import Small from 'UIComponents/elements/Small';
import UITable from 'UIComponents/table/UITable';
import Markdown from '../../Doc/components/Markdown';
import TypesList from './TypesList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTable = styled(UITable).withConfig({
  displayName: "ResponseSchemaBody__StyledTable",
  componentId: "qul6y2-0"
})(["background-color:", ";border:0;"], TABLE_HEADER_BACKGROUND_COLOR);
const cellStyles = css(["&&{padding-top:4px;padding-bottom:4px;vertical-align:top;height:auto;border-width:0;}"]);
const StyledTH = styled.th.withConfig({
  displayName: "ResponseSchemaBody__StyledTH",
  componentId: "qul6y2-1"
})(["", ""], cellStyles);
const StyledTD = styled.td.withConfig({
  displayName: "ResponseSchemaBody__StyledTD",
  componentId: "qul6y2-2"
})(["", ""], cellStyles);
export default class ResponseSchemaBody extends Component {
  renderType(type) {
    const arrayMatch = type.match(/^\[(.*)\]$/);
    if (arrayMatch && arrayMatch[1]) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: `developer-docs-shared-components.types.array.${arrayMatch[1].toLowerCase()}`,
        options: {
          defaultValue: type
        }
      });
    } else {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: `developer-docs-shared-components.types.${type.toLowerCase()}`,
        options: {
          defaultValue: type
        }
      });
    }
  }
  renderSchemaType() {
    const {
      schema,
      oas
    } = this.props;
    if (schema.oneOf) {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "developer-docs-shared-components.oneOfDescription_jsx",
        elements: {
          TypesList
        },
        options: {
          types: getOneOfTypes(schema.oneOf, oas)
        }
      });
    } else if (schema.type !== 'array') {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `developer-docs-shared-components.response.schemaType.${schema.type}`,
        options: {
          defaultValue: capitalizeFirstLetter(schema.type)
        }
      });
    } else if (schema.items.$ref) {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "developer-docs-shared-components.response.schemaType.arrayOf.objects"
      });
    }
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "developer-docs-shared-components.response.schemaType.arrayOf.other",
      options: {
        type: schema.items.type
      }
    });
  }
  renderRows() {
    const {
      schema,
      oas
    } = this.props;
    const rows = flatten(flattenResponseSchema(schema, oas));
    return rows.map(row => /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsx(StyledTH, {
        className: "text-right",
        children: /*#__PURE__*/_jsx(Code, {
          className: "transparent",
          children: this.renderType(row.type)
        })
      }), /*#__PURE__*/_jsxs(StyledTD, {
        className: "",
        children: [/*#__PURE__*/_jsx(Code, {
          className: "transparent",
          children: row.name
        }), row.description && /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: typeof row.description === 'string' ? /*#__PURE__*/_jsx(Markdown, {
              inline: true,
              children: row.description
            }) : row.description
          })]
        })]
      })]
    }, row.name));
  }
  renderSchemaBody() {
    return /*#__PURE__*/_jsxs("div", {
      children: [this.renderSchemaType(), /*#__PURE__*/_jsxs(StyledTable, {
        className: "response-body-schema",
        condensed: true,
        hover: false,
        children: [/*#__PURE__*/_jsxs("colgroup", {
          children: [/*#__PURE__*/_jsx("col", {
            style: {
              width: 100
            }
          }), /*#__PURE__*/_jsx("col", {})]
        }), /*#__PURE__*/_jsx("tbody", {
          children: this.renderRows()
        })]
      })]
    });
  }
  render() {
    return this.props.collapsible ? /*#__PURE__*/_jsx(UIExpandableText, {
      use: "on-dark",
      maxHeight: 400 + EXPANDABLE_TEXT_HEIGHT_OFFSET,
      expandButtonText: I18n.text('developer-docs-shared-components.params.body.newExpandButton'),
      collapseButtonText: I18n.text('developer-docs-shared-components.params.body.newCollapseButton'),
      buttonAlign: "left",
      gradientColor: "transparent",
      children: this.renderSchemaBody()
    }) : this.renderSchemaBody();
  }
}
ResponseSchemaBody.propTypes = {
  schema: PropTypes.object.isRequired,
  oas: PropTypes.instanceOf(Oas).isRequired,
  collapsible: PropTypes.boolean
};